import { IconButton, type IconButtonProps } from '@chakra-ui/react';

/**
 * A ghost icon button for the editor toolbar's right zone. It bakes in the shared
 * `variant="ghost" size="sm"` look and a negative horizontal margin: a ghost
 * button carries invisible padding around its glyph, so without the pull-in the
 * glyph-to-neighbour gap reads wider than the gap next to a hard-edged neighbour
 * (the bordered Published pill, the solid Preview/Publish buttons). The `mx`
 * claws the glyph back to its ink so every control in the group sits on the same
 * visual rhythm. Every consumer wraps it in a `Box` for its popover/tooltip
 * trigger, so it does not need to forward a ref of its own.
 */
export function ToolbarIconButton(props: IconButtonProps) {
  return <IconButton variant="ghost" size="sm" mx="-1" {...props} />;
}
